import { Document, Paragraph, TextRun, Packer } from "docx";
import {
  TMeetingInfo,
  TSpeakerContent,
} from "../../../services/api/instances/meetingsApi/types";

const sanitizeAndTruncateFileName = (name: string): string => {
  if (!name || name.trim() === "") return "transcript";

  let cleaned = name
    .replace(/[<>:"/\\|?*]/g, "_")
    .replace(/\s+/g, "_")
    .replace(/^_+|_+$/g, "");

  const words = cleaned.split("_");

  const truncatedWords = words.slice(0, 4);

  return (
    truncatedWords.filter((word) => word.length > 0).join("_") || "transcript"
  );
};

export const exportTranscriptToDocx = async (
  meetingInfo: TMeetingInfo,
  transcription: TSpeakerContent[],
) => {
  const { meeting_name, meeting_date, meeting_description } = meetingInfo;

  let dateForName: Date;
  let baseName: string;

  if (meeting_name && meeting_date) {
    dateForName = new Date(meeting_date);
    baseName = sanitizeAndTruncateFileName(meeting_name);
  } else {
    dateForName = new Date();
    baseName = "Стенограмма";
  }

  const datePart = dateForName
    .toLocaleString("ru-RU", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour12: false,
    })
    .replace(/\./g, "");

  const timePart = dateForName
    .toLocaleString("ru-RU", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    })
    .replace(/\./g, "")
    .replace(/:/g, "");

  const filename = `${datePart}_${timePart}_001_${baseName}.docx`;

  const paragraphs = [];

  if (meeting_name) {
    paragraphs.push(
      new Paragraph({
        children: [
          new TextRun({ text: `Название встречи: `, bold: true }),
          new TextRun(meeting_name),
        ],
      }),
    );
  } else {
    paragraphs.push(
      new Paragraph({ children: [new TextRun("Название встречи: ")] }),
    );
  }

  if (meeting_date) {
    const date = new Date(meeting_date);
    const formattedDate = `${date.getDate()} ${date.toLocaleString("ru-RU", { month: "long" })} ${date.getFullYear()} г.`;
    paragraphs.push(
      new Paragraph({
        children: [
          new TextRun({ text: `Дата: `, bold: true }),
          new TextRun(formattedDate),
        ],
      }),
    );
  } else {
    paragraphs.push(new Paragraph({ children: [new TextRun("Дата: ")] }));
  }

  if (meeting_description) {
    paragraphs.push(
      new Paragraph({
        children: [
          new TextRun({ text: `Описание: `, bold: true }),
          new TextRun(meeting_description),
        ],
      }),
    );
  } else {
    paragraphs.push(new Paragraph({ children: [new TextRun("Описание: ")] }));
  }

  paragraphs.push(new Paragraph({ children: [new TextRun("")] }));

  transcription.forEach((item) => {
    paragraphs.push(
      new Paragraph({
        children: [
          new TextRun({ text: `${item.speaker_name}: `, bold: true }),
          new TextRun(item?.speech_content ?? ""),
        ],
      }),
    );
  });

  const doc = new Document({
    sections: [
      {
        children: paragraphs,
      },
    ],
  });

  const blob = await Packer.toBlob(doc);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
